import React from 'react';
import { Quote } from 'lucide-react';

interface TestimonialProps {
  quote: string;
  customerName: string;
  zone: string;
}

export default function Testimonial({ quote, customerName, zone }: TestimonialProps) {
  return (
    <div className="max-w-2xl mx-auto my-8">
      <div className="bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200 rounded-lg p-6 shadow-sm">
        <div className="flex items-start gap-3">
          <Quote className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" />
          <div className="flex-1">
            <p className="text-gray-800 italic mb-3 leading-relaxed">
              "{quote}"
            </p>
            <div className="flex items-center gap-2 text-sm">
              <span className="font-semibold text-gray-900">– {customerName}</span>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                {zone}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
